import styles from "./copyright.module.css";

const Copyright = () => {
    return (
        <div className="grid w-full">
            <div className="grid-cols-1 text-center pb-10 pt-5">
                <div className={styles.text}>
                    <i className="fal fa-copyright"></i> 2022 Sajad Kolahchi . All rights reserved <i className={`${styles.heart} fas fa-heart`}></i>
                </div>
            </div>
        </div>);
}

export default Copyright;